export const getInitials = ( firstname?: string, lastname?: string ): string => {
    const first = firstname?.trim()?.[0] ?? "";
    const last = lastname?.trim()?.[0] ?? "";

    return `${first}${last}`.toUpperCase();
};